import controlled from './free-drainage.jpg';
import positive from './positive-drainage.jpg';

export default {
  'Controlled Drainage': controlled,
  'Positive Drainage': positive,
};
